<template>
  <div class="component-interaction-attr-condition">
    <el-form-item label="满足条件执行"><i class="el-icon-plus" @click="addList(conforms)"></i></el-form-item>
    <div class="list" v-for="(item, i) in conforms" :key="'conforms'+i">
      <el-form-item :prop="'conforms.'+i+'.actionType'" :rules="{required: true, message: '请选择执行事件', trigger: 'change'}">
        <el-select v-model="item.actionType" filterable clearable placeholder="请选择执行事件" @change="item.changeComponent=''">
          <el-option
            v-for="option in actionOptions"
            :key="option.value"
            :label="option.name"
            :value="option.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :prop="'conforms.'+i+'.changeComponent'" :rules="{required: true, message: '请选择执行控件', trigger: 'change'}">
        <el-select v-model="item.changeComponent" multiple collapse-tags filterable clearable  placeholder="请选择执行控件" remote :remote-method="remoteMethod">
          <el-option
            v-for="option in conformsControls"
            :disabled="disabled(option, item)"
            :key="option.id"
            :label="label(option)"
            :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="fx" v-show="item.actionType === 'calculate'" @click="$emit('openCalculate',item.calculate, item)">fx</div>
      <span class="close-list" @click="delList(conforms, i)">x</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'component-interaction-attr-condition',
  props: {
    type: String,
    conforms: Array,
    conformsControls: Array,
    triggerComponents: Array,
    options: Array,
    isProcess: Boolean
  },
  data () {
    return {
      actionOptions: [
        {name: '显示', value: 'show'},
        {name: '隐藏占位', value: 'visibility'},
        {name: '隐藏不占位', value: 'hidden'},
        {name: '只读', value: 'readonly'},
        {name: '可编辑', value: 'edit'},
        {name: '必填', value: 'required'},
        {name: '非必填', value: 'noRequired'},
        {name: '计算', value: 'calculate'},
        {name: '清空', value: 'clear'}
      ]
    }
  },
  computed: {
    label () {
      return function (option) {
        let label = option.name
        if (option.tableName) {
          label = `${option.tableName}-${label}`
        }
        if (this.isProcess) {
          label = `${option.formName}-${label}`
        }
        return label
      }
    },
    disabled () {
      return function (option, item) {
        // 显示隐藏不占位只对分组控件
        if (['visibility', 'readonly', 'edit', 'required', 'noRequired', 'calculate', 'clear'].some(n => item.actionType.includes(n)) && option.componentType === 'rc-group') {
          return true
        }

        // 一旦选择了表格内的控件那无法选择执行控件
        for (let i = 0; i < this.triggerComponents.length; i++) {
          if (this.triggerComponents[i].triggerComponent === option.id) {
            return true
          }
          let triggerComponent = this.options.find(option => option.id === this.triggerComponents[i].triggerComponent)
          if (triggerComponent && triggerComponent.tableId && triggerComponent.tableId !== option.tableId) {
            return true
          }
        }
        return false
      }
    }
  },
  methods: {
    addList (arr) {
      arr.push({changeComponent: [], actionType: '', calculate: ''})
    },
    delList (arr, index) {
      arr.splice(index, 1)
    },
    // 满足条件执行
    remoteMethod (query) {
      if (query !== '') {
        this.conformsControls = this.$_.merge([], this.options).filter(t => t.name.includes(query) || (t.pnl && t.pnl.includes(query)) || (t.pfcl && t.pfcl.includes(query)))
      } else {
        this.conformsControls = this.$_.merge([], this.options)
      }
    }
  }
}
</script>

<style lang="scss">
  .component-interaction-attr-condition{

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/componentInteractionAttrChildren/component-interaction-conforms.vue